export enum ParcsOrganizations {
  AMANO_ONE_PARCS_ID = 'BE4BEE39-A831-4BBE-9BD7-D99FF9086677',
  FLASH_PARCS_ID = 'ACF0B22F-CBCE-4B52-ACE2-4975E46D76EA',
}

export enum SendInvoiceQueryBalanceDateType {
  InvocieWithBalance = 1,
  IncludeZeroBalance = 2,
  ZeroBalanceOnly = 3,
  LessThanZeroBalance = 4,
  PastDueBalance = 5,
}
